import axios from 'axios';
import { getAuth } from '../providers/AppAuthProvider';

import { API_BASE_URL as baseUrl } from 'src/utils/api-url';
import { sanitizeUploadFilename } from 'src/utils/upload-filename';

// 直接走 cdn-service 上传，附带 fileType/tags/pathPrefix/customFilename
export async function bannersUpload(
  file: File,
  options: {
    uploadUrl: string;
    fileType?: string;
    tags?: string;
    pathPrefix?: string;
    customFilename?: string;
  }
) {
  console.log('bannersUpload file and options:', file, options);
  const formData = new FormData();
  formData.append('file', file);
  formData.append('fileType', options?.fileType || 'IMAGE');
  formData.append('tags', options?.tags || 'webBanners');
  formData.append('pathPrefix', options?.pathPrefix || 'webBanners');
  formData.append('customFilename', sanitizeUploadFilename(options?.customFilename || file.name));

  const { accessToken } = (await getAuth()) || {};
  const headers = {
    Authorization: accessToken ? `Bearer ${accessToken}` : '',
    Accept: 'application/json',
    // 不要手动设置 Content-Type，axios 会自动生成 multipart/form-data boundary
  };
  const response = await axios.post<any>(options.uploadUrl, formData, { headers });
  return response.data;
}

export async function bannersUploadByServer(
  file: File,
  options: {
    uploadUrl: string;
    fileType?: string;
    tags?: string;
    pathPrefix?: string;
    customFilename?: string;
  }
) {
  console.log('bannersUpload file and options:', file, options);
  const formData = new FormData();
  formData.append('file', file);
  formData.append('fileType', options?.fileType || 'IMAGE');
  formData.append('tags', options?.tags || 'webBanners');
  formData.append('pathPrefix', options?.pathPrefix || 'webBanners');
  formData.append('customFilename', sanitizeUploadFilename(options?.customFilename || file.name));

  const { accessToken } = (await getAuth()) || {};
  const headers = {
    Authorization: accessToken ? `Bearer ${accessToken}` : '',
    Accept: 'application/json',
    // 不要手动设置 Content-Type，axios 会自动生成 multipart/form-data boundary
  };
  const url = `${baseUrl}/banners/upload`;
  const response = await axios.post<any>(url, formData, { headers });
  return response.data;
}
